import { render, staticRenderFns } from "./ChatBox.vue?vue&type=template&id=22db1de0"
import script from "./ChatBox.vue?vue&type=script&lang=js"
export * from "./ChatBox.vue?vue&type=script&lang=js"
import style0 from "./ChatBox.vue?vue&type=style&index=0&id=22db1de0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports